// //Quick View
// $(document).ready(function () {
//   $.getScript("//cdnjs.cloudflare.com/ajax/libs/fancybox/2.1.5/jquery.fancybox.min.js").done(function() {
//     quickView();
//   });
// });
// function quickView() {
//   $(".quick-view").click(function () {
//     if ($('#quick-view').length == 0){$("body").append('<div id="quick-view"></div>');}
//     $('#quick-view').html(`
//       <div class="qv-loading">
//         Loading product...
//       </div>
//     `);
//     var product_handle = $(this).data('handle');
//     $('#quick-view').addClass(product_handle);

//     // Open fancybox immediately
//     // $.fancybox({
//     //   href: '#quick-view',
//     //   maxWidth: 1040,
//     //   maxHeight: 600,
//     //   fitToView: true,
//     //   width: '75%',
//     //   height: '70%',
//     //   autoSize: false,
//     //   closeBtn: true,
//     //   closeClick: false,
//     //   openEffect: 'none',
//     //   closeEffect: 'none',
//     //   afterClose: function () {
//     //     $('#quick-view').removeClass().empty();
//     //   }
//     // });

//     jQuery.getJSON('/products/' + product_handle + '.js', function(product) {
//     var title = product.title;
//     var type = product.type;
//     var desc = product.description;
//     var images = product.images;
//     var options = product.options;
//     var variants = product.variants;
//     var url = '/products/' + product_handle;
//     $('.qv-product-title').text(title);
//     $('.qv-product-type').text(type);
//     $('.qv-product-description').html(desc);
//     $('.view-product').attr('href', url);
//     // Product Images
//     $('.qv-product-images').empty();
//     $('.qv-product-thumbnails').empty();
//     $(images).each(function(i, image) {
//         var image_embed =
//             '<div class="quick-mian-image" ><img src="' +
//             image.replace('.jpg', '_800x.jpg').replace('.png', '_800x.png') +
//             '"></div>';
//             var image_embed_thmb =
//             '<div class="thumbnail-inner-image"  data-index="' + i + '"><img src="' +
//             image.replace('.jpg', '_300x.jpg').replace('.png', '_300x.png') +
//             '"></div>';
//         $('.qv-product-images').append(image_embed);
//         $('.qv-product-thumbnails').append(image_embed_thmb);
//     });

//     // Show first image
//     $('.quick-mian-image').hide().first().show();
//     $('.thumbnail-inner-image').first().addClass('active');

//     $('.qv-product-imageds').slick({
//     slidesToShow: 1,
//     slidesToScroll: 1,
//     arrows: false,
//     asNavFor: '.qv-product-thumbnails'
// }).css('opacity', '1');

// $('.qv-product-thumbnailss').slick({
//     slidesToShow: 4,
//     slidesToScroll: 1,
//     asNavFor: '.qv-product-images',
//     focusOnSelect: true
// }).css('opacity', '1');
//     // Clear existing options
//     $('.qv-product-options').empty();
//     // Clear existing options
//     // $('.qv-product-thumbnails').empty();
//     // Create Swatches
//     $(options).each(function(optionIndex, option) {
//         var optionName = option.name;
//         if(optionName == "Colour" || optionName == "Color" || optionName == "color" || optionName == "colour" )
//         { }
//         else {
//         var html =
//             '<div class="option-wrapper">' +
//                 '<div class="option-title">' + optionName + '</div>' +
//                 '<div class="variant-swatches option-group-' + optionIndex + '">' +
//                 '</div>' +
//             '</div>';
//         $('.qv-product-options').append(html);
//         $(option.values).each(function(valueIndex, value) {
//             $('.option-group-' + optionIndex).append(
//                 '<button type="button" ' +
//                 'class="variant-swatch" ' +
//                 'data-option-index="' + optionIndex + '" ' +
//                 'data-value="' + value + '">' +
//                 value +
//                 '</button>'
//             );
//         });
//       }
//     });
//     // Select first available variant
//     var firstVariant = variants.find(function(v) {
//         return v.available;
//     }) || variants[0];
//     if (firstVariant) {
//         $('[data-option-index="0"][data-value="' + firstVariant.option1 + '"]').addClass('active');
//         if (firstVariant.option2) {
//             $('[data-option-index="1"][data-value="' + firstVariant.option2 + '"]').addClass('active');
//         }
//         if (firstVariant.option3) {
//             $('[data-option-index="2"][data-value="' + firstVariant.option3 + '"]').addClass('active');
//         }
//         updateVariant(firstVariant);
//     }
//     // Swatch Click
//     $(document).off('click', '.variant-swatch');
//     $(document).on('click', '.variant-swatch', function() {
//         var optionIndex = $(this).data('option-index');
//         $('.option-group-' + optionIndex + ' .variant-swatch').removeClass('active');
//         $(this).addClass('active');
//         findMatchingVariant();
//     });
//     function findMatchingVariant() {
//         var selected1 = $('[data-option-index="0"].active').data('value') || null;
//         var selected2 = $('[data-option-index="1"].active').data('value') || null;
//         var selected3 = $('[data-option-index="2"].active').data('value') || null;
//         var matchedVariant = variants.find(function(v) {
//             return (
//                 (selected1 === null || v.option1 === selected1) &&
//                 (selected2 === null || v.option2 === selected2) &&
//                 (selected3 === null || v.option3 === selected3)
//             );
//         });
//         if (matchedVariant) {
//             updateVariant(matchedVariant);
//         }
//     }
//     function updateVariant(variant) {
//         var price = (variant.price / 100).toFixed(2);
//         $('.qv-product-price').text('Rs. ' + price);
//         if (variant.compare_at_price) {
//             $('.qv-product-original-price')
//                 .text('Rs. ' + (variant.compare_at_price / 100).toFixed(2))
//                 .show();
//         } else {
//             $('.qv-product-original-price').hide();
//         }
//         if (!variant.available) {
//             $('.qv-add-button')
//                 .prop('disabled', true)
//                 .val('Sold Out');
//         } else {
//             $('.qv-add-button')
//                 .prop('disabled', false)
//                 .val('Add To Cart');
//         }
//         $('.qv-add-button').attr('data-variant-id', variant.id);
//     }
// });
//     $(document).on("change", "#quick-view select", function () {
//       var selectedOptions = '';
//       $('#quick-view select').each(function (i) {
//         if (selectedOptions == '') {
//           selectedOptions = $(this).val();
//         } else {
//           selectedOptions = selectedOptions + ' / ' + $(this).val();
//         }
//       });
//       jQuery.getJSON('/products/' + product_handle + '.js', function (product) {
//         $(product.variants).each(function (i, v) {
//           if (v.title == selectedOptions) {
//             var price = parseFloat(v.price / 100).toFixed(2);
//             var original_price = parseFloat(v.compare_at_price / 100).toFixed(2);
//             var v_qty = v.inventory_quantity;
//             var v_inv = v.inventory_management;
//             $('.qv-product-price').text('$' + price);
//             $('.qv-product-original-price').text('$' + original_price);
//             if (v_inv == null) {
//               $('.qv-add-button').prop('disabled', false).val('Add to Cart');
//             } else {
//               if (v.inventory_quantity < 1) {
//                 $('.qv-add-button').prop('disabled', true).val('Sold Out');
//               } else {
//                 $('.qv-add-button').prop('disabled', false).val('Add to Cart');
//               }
//             }
//           }
//         });
//       });
//     });
//     $.fancybox({
//       href: '#quick-view',
//       maxWidth: 1040,
//       maxHeight: 600,
//       fitToView: true,
//       width: '75%',
//       height: '70%',
//       autoSize: false,
//       closeBtn: true,
//       closeClick: false,
//       openEffect: 'none',
//       closeEffect: 'none',
//       'beforeLoad': function () {
//         var product_handle = $('#quick-view').attr('class');
//       $(document).off("click", ".qv-add-button").on("click", ".qv-add-button", function () {

//     var qty = $('.qv-quantity').val() || 1;
//     var var_id = $(this).data('variant-id');

//     if (!var_id) {
//         alert("Please select a variant.");
//         return;
//     }

//     $.ajax({
//         type: "POST",
//         url: "/cart/add.js",
//         data: {
//             id: var_id,
//             quantity: qty
//         },
//         dataType: "json",
//         success: function () {

//     $('.qv-add-to-cart-response')
//         .removeClass('error')
//         .addClass('success')
//         .html('<span>' + $('.qv-product-title').text() + ' has been added to your cart.</span>');

//     fetch('/cart.js')
//         .then(response => response.json())
//         .then(cart => {

//             document.documentElement.dispatchEvent(
//                 new CustomEvent('cart:refresh', {
//                     bubbles: true,
//                     detail: {
//                         cart: cart,
//                         openMiniCart: true
//                     }
//                 })
//             );
//            // Close Quick View popup
//             $.fancybox.close();
//         });

// },
//         error: function (xhr) {
//             $('.qv-add-to-cart-response')
//                 .removeClass('success')
//                 .addClass('error')
//                 .html(xhr.responseJSON.description);
//         }
//     });

// });
//         // $('.fancybox-wrap').css('overflow', 'hidden !important');
//       },
//       'afterShow': function () {
//           $('#quick-view').hide().html(content).css('opacity', '1').fadeIn(function () {
//             $('.qv-product-images').addClass('loaded');
//             $('.qv-product-thumbnails').addClass('loaded');
//           });
//       },
//       'afterClose': function () {
//         $('#quick-view').removeClass().empty();
//       }
//     });
//   });
// };


// $(document).on('click', '.thumbnail-inner-image', function () {

//     var index = $(this).data('index');

//     $('.thumbnail-inner-image').removeClass('active');
//     $(this).addClass('active');

//     $('.quick-mian-image').hide();
//     $('.quick-mian-image').eq(index).show();

// });

// $(window).resize(function () {
//   if ($('#quick-view').is(':visible')) {
//     $('.qv-product-images').slick('setPosition');
//     $('.qv-product-thumbnails').slick('setPosition');
//   }
// });

//Quick View
$(document).ready(function () {
  if (typeof $.fancybox === 'function') {
    quickView();
  } else {
    $.getScript("//cdnjs.cloudflare.com/ajax/libs/fancybox/2.1.5/jquery.fancybox.min.js")
      .done(function () {
        quickView();
      })
      .fail(function (jqxhr, settings, exception) {
        console.error('Failed to load fancybox:', exception);
      });
  }
});

var qvCache = {};

function quickView() {

  // Prefetch product data on hover (desktop) so it's often already
  // cached by the time the user actually clicks
  $(document).on('mouseenter', '.quick-view', function () {
    var handle = $(this).data('handle');
    if (handle && !qvCache[handle]) {
      jQuery.getJSON('/products/' + handle + '.js', function (product) {
        qvCache[handle] = product;
      });
    }
  });

  $(document).on('click', '.quick-view', function () {
    if ($('#quick-view').length == 0) { $("body").append('<div id="quick-view"></div>'); }

    var product_handle = $(this).data('handle');
    $('#quick-view').removeClass().addClass(product_handle);

    // Inject loader + real markup (hidden until data is ready)
    $('#quick-view').html(`
      <div class="qv-loading">
        Loading product...
      </div>
      <section class="quick-mainmain" style="display:none;">
        <div class="quick-main-left">
          <div class="qv-product-thumbnails"></div>
          <div class="qv-product-imagesmain">
            <div class="qv-product-images"></div>
          </div>
        </div>
        <div class="qv-content">
          <div class="holder">
            <h3 class="qv-product-title"></h3>
            <h5 class="qv-product-price"></h5>
            <h5 class="qv-product-original-price"></h5>
            <hr />
            <div class="qv-add-to-cart">
              <div class="qv-product-options"></div>
              <div class="quantity" style="display:none;">
                <span>Quantity</span>
                <input type="number" class="qv-quantity" value="1" min="1">
              </div>
              <input type="submit" class="qv-add-button" value="Add to Cart">
              <div class="qv-add-to-cart-response"></div>
            </div>
            <div class="product-form__text"><p>🚚 Delivery in 7–10 working days<br>📍 Remote pin codes may take longer</p></div>
          </div>
          <a class="view-productee" href=""><span>View details</span></a>
        </div>
      </section>
    `);

    $.fancybox({
      href: '#quick-view',
      maxWidth: 1040,
      maxHeight: 600,
      fitToView: true,
      width: '75%',
      height: '70%',
      autoSize: false,
      closeBtn: true,
      closeClick: false,
      openEffect: 'none',
      closeEffect: 'none',
      afterClose: function () {
        $('#quick-view').removeClass().empty();
      }
    });

    loadProduct(product_handle);
  });
}

function loadProduct(product_handle) {
  if (qvCache[product_handle]) {
    renderProduct(qvCache[product_handle], product_handle);
    return;
  }
  jQuery.getJSON('/products/' + product_handle + '.js', function (product) {
    qvCache[product_handle] = product;
    renderProduct(product, product_handle);
  });
}

function renderProduct(product, product_handle) {
  // Reveal real content, hide loader
  $('#quick-view .qv-loading').hide();
  $('#quick-view .quick-mainmain').show();

  var title = product.title;
  var images = product.images;
  var options = product.options;
  var variants = product.variants;
  var url = '/products/' + product_handle;

  $('.qv-product-title').text(title);
  $('.view-productee').attr('href', url);

  // Reset add button state in case a previous product left it disabled
  $('.qv-add-button').prop('disabled', false).val('Add to Cart');
  $('.qv-add-to-cart-response').removeClass('success error').empty();

  // Product Images
  $('.qv-product-images').empty();
  $('.qv-product-thumbnails').empty();

  $(images).each(function (i, image) {
    var bigSrc = image.replace('.jpg', '_800x.jpg').replace('.png', '_800x.png');
    var thumbSrc = image.replace('.jpg', '_300x.jpg').replace('.png', '_300x.png');
    var loading = i === 0 ? 'eager' : 'lazy';

    var image_embed =
      '<div class="quick-mian-image"><img src="' + bigSrc + '" loading="' + loading + '"></div>';
    var image_embed_thmb =
      '<div class="thumbnail-inner-image" data-index="' + i + '"><img src="' + thumbSrc + '" loading="' + loading + '"></div>';

    $('.qv-product-images').append(image_embed);
    $('.qv-product-thumbnails').append(image_embed_thmb);
  });

  $('.quick-mian-image').hide().first().show();
  $('.thumbnail-inner-image').removeClass('active').first().addClass('active');

  // Options / swatches
$('.qv-product-options').empty();
$(options).each(function (optionIndex, option) {
  var optionName = option.name;
  if (['Colour', 'Color', 'color', 'colour'].indexOf(optionName) === -1) {
    var html =
      '<div class="option-wrapper">' +
        '<div class="option-title">' + optionName + '</div>' +
        '<div class="variant-swatches option-group-' + optionIndex + '"></div>' +
      '</div>';
    $('.qv-product-options').append(html);
    $(option.values).each(function (valueIndex, value) {
      $('.option-group-' + optionIndex).append(
        '<button type="button" class="variant-swatch" data-option-index="' + optionIndex + '" data-value="' + value + '">' +
        value + '</button>'
      );
    });
  }
});

// NEW: mark swatches unavailable based on current selection
markUnavailableSwatches();

  var firstVariant = variants.find(function (v) { return v.available; }) || variants[0];
  if (firstVariant) {
    $('[data-option-index="0"][data-value="' + firstVariant.option1 + '"]').addClass('active');
    if (firstVariant.option2) $('[data-option-index="1"][data-value="' + firstVariant.option2 + '"]').addClass('active');
    if (firstVariant.option3) $('[data-option-index="2"][data-value="' + firstVariant.option3 + '"]').addClass('active');
    updateVariant(firstVariant);
    markUnavailableSwatches(); // NEW
  }

  function markUnavailableSwatches() {
  $('.variant-swatch').each(function () {
    var $swatch = $(this);
    var optionIndex = $swatch.data('option-index');
    var value = $swatch.data('value');

    // Build the current selection, substituting this swatch's value
    // into its own option slot, to see if ANY matching variant is available
    var selections = [null, null, null];
    $('.variant-swatch.active').each(function () {
      var i = $(this).data('option-index');
      selections[i] = $(this).data('value');
    });
    selections[optionIndex] = value;

    var matches = variants.filter(function (v) {
      return (selections[0] === null || v.option1 === selections[0]) &&
             (selections[1] === null || v.option2 === selections[1]) &&
             (selections[2] === null || v.option3 === selections[2]);
    });

    var anyAvailable = matches.some(function (v) { return v.available; });
    $swatch.toggleClass('sold-out', !anyAvailable);
  });
}


  $(document).off('click', '.variant-swatch').on('click', '.variant-swatch', function () {
    var optionIndex = $(this).data('option-index');
    $('.option-group-' + optionIndex + ' .variant-swatch').removeClass('active');
    $(this).addClass('active');

    var selected1 = $('[data-option-index="0"].active').data('value') || null;
    var selected2 = $('[data-option-index="1"].active').data('value') || null;
    var selected3 = $('[data-option-index="2"].active').data('value') || null;
    var matchedVariant = variants.find(function (v) {
      return (selected1 === null || v.option1 === selected1) &&
             (selected2 === null || v.option2 === selected2) &&
             (selected3 === null || v.option3 === selected3);
    });
    if (matchedVariant) updateVariant(matchedVariant);
      markUnavailableSwatches(); // NEW
  });

  function updateVariant(variant) {
    var price = (variant.price / 100).toFixed(0);
    $('.qv-product-price').text('Rs. ' + price);
    if (variant.compare_at_price && variant.compare_at_price > variant.price) {
      $('.qv-product-original-price').text('Rs. ' + (variant.compare_at_price / 100).toFixed(0)).show();
    } else {
      $('.qv-product-original-price').hide();
    }
    if (!variant.available) {
      $('.qv-add-button').prop('disabled', true).val('Sold Out');
    } else {
      $('.qv-add-button').prop('disabled', false).val('Add to Cart');
    }
    $('.qv-add-button').attr('data-variant-id', variant.id);
  }

  // Add to Cart — closes popup immediately, cart drawer updates in background
  $(document).off('click', '.qv-add-button').on('click', '.qv-add-button', function (e) {
    e.preventDefault();
    var $btn = $(this);
    var qty = $('.qv-quantity').val() || 1;
    var var_id = $btn.data('variant-id');
    if (!var_id) { alert("Please select a variant."); return; }

    $btn.prop('disabled', true).val('Adding...');

    $.ajax({
      type: "POST",
      url: "/cart/add.js",
      data: { id: var_id, quantity: qty },
      dataType: "json",
      success: function () {
        // Close right away — don't wait on cart.js or the drawer render
       

        // Update cart drawer in the background
        fetch('/cart.js')
          .then(response => response.json())
          .then(cart => {
            document.documentElement.dispatchEvent(
              new CustomEvent('cart:refresh', {
                bubbles: true,
                detail: { cart: cart, openMiniCart: true }
              })
            );
            setTimeout(function () {
                $.fancybox.close();
              }, 150); // small buffer so drawer animation has started
            });
           
      },
      error: function (xhr) {
        $btn.prop('disabled', false).val('Add to Cart');
        $('.qv-add-to-cart-response')
          .removeClass('success').addClass('error')
          .html(xhr.responseJSON.description);
      }

      

    });
  });
}

// Thumbnail click — swap main image
$(document).on('click', '.thumbnail-inner-image', function () {
  var index = $(this).data('index');
  $('.thumbnail-inner-image').removeClass('active');
  $(this).addClass('active');
  $('.quick-mian-image').hide().eq(index).show();
});